export function convertBase64ToBlob(base64StringOrDataUrl, mimeType = "image/png") {
    let base64String = base64StringOrDataUrl;

    if (base64StringOrDataUrl.startsWith("data:")) {
        base64String = base64StringOrDataUrl.split(",")[1];
        const mimeMatch = base64StringOrDataUrl.split(",")[0].match(/^data:([^;]+);/);
        if (mimeMatch) {
            mimeType = mimeMatch[1];
        }
    }

    const byteString = atob(base64String);

    const byteNumbers = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        byteNumbers[i] = byteString.charCodeAt(i);
    }

    return new Blob([byteNumbers], { type: mimeType });
}